import { PortCallPurpose } from '@navstation-portal/reporting/data-model/vessel-report';
import { authEvents } from '@navstation-portal/shared/data-access/auth';
import { signalStoreFeature, withState } from '@ngrx/signals';
import { on, withReducer } from '@ngrx/signals/events';
import { operationalReferenceDataEvents } from './operational-events';

export function withPortCallPurposesReducer() {
  return signalStoreFeature(
    withState({
      portCallPurposes: [] as PortCallPurpose[],
    }),
    withReducer(
      on(operationalReferenceDataEvents.getPortCallPurposesSuccess, ({ payload }) => ({ portCallPurposes: payload })),
      on(authEvents.logoutSuccess, () => ({ portCallPurposes: [] }))
    )
  );
}
